import React from 'react';
import { Button, Input } from 'antd';
import { MinusOutlined, PlusOutlined } from '@ant-design/icons';

const Counter = ({
  value,
  onChange,
  labelSingular = '',
  isSmall = false,
  rightLabel = '',
  max = Infinity,
  fullWidth = false,
}) => {
  const increment = () => {
    if (value < max) {
      onChange(value + 1);
    }
  };

  const decrement = () => {
    if (value > 1) {
      onChange(value - 1);
    }
  };

  const formatLabel = (count, label) => {
    if (!label) return count.toString();
    const labelPlural = `${label}${label.endsWith('s') ? 'es' : 's'}`;
    return `${count} ${count > 1 ? labelPlural : label}`;
  };

  const formatRightLabel = (count, label) => {
    if (!label) return '';
    const labelPlural = `${label}${label.endsWith('s') ? 'es' : 's'}`;
    return count > 1 ? labelPlural : label;
  };

  const containerStyle = {
    display: 'flex',
    alignItems: 'center',
    width: fullWidth ? '100%' : 'fit-content',
  };

  const buttonStyle = {
    ...(isSmall
      ? {
          width: '28px',
          height: '28px',
          minWidth: '28px',
        }
      : {}),
    opacity: 1,
  };

  const inputStyle = {
    textAlign: 'center',
    margin: '0 12px',
    width: fullWidth ? '100%' : isSmall ? '60px' : 'auto',
    height: isSmall ? '28px' : 'auto',
  };

  const rightLabelStyle = {
    marginLeft: '8px',
    fontSize: isSmall ? '16px' : '16px',
  };

  return (
    <div style={containerStyle}>
      <Button
        shape="circle"
        icon={<MinusOutlined />}
        onClick={decrement}
        className="bg-neutral-400"
        style={buttonStyle}
        disabled={value <= 1}
      />
      <Input
        className="ant-input-number"
        style={inputStyle}
        value={labelSingular ? formatLabel(value, labelSingular) : value}
        readOnly
      />
      <Button
        shape="circle"
        icon={<PlusOutlined />}
        onClick={increment}
        className="bg-neutral-400"
        style={buttonStyle}
        disabled={value >= max}
      />
      {rightLabel && <span style={rightLabelStyle}>{formatRightLabel(value, rightLabel)}</span>}
    </div>
  );
};

export default Counter;
